import type { ConversationId } from "@redotech/effect-api-shared/ids/definitions";
import { RedoSpinner } from "@redotech/redo-web/arbiter-components/loading/redo-spinner";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { useConversationTimelineEvents } from "../../hooks/use-conversation-data";
import * as styles from "./conversation-timeline.module.css";
import { TimelineEventCard } from "./timeline-event-card";

export interface ConversationTimelineProps {
  conversationId: ConversationId;
}

export const ConversationTimeline = memo(function ConversationTimeline({
  conversationId,
}: ConversationTimelineProps) {
  const { data: events, isLoading } =
    useConversationTimelineEvents(conversationId);

  if (isLoading) {
    return (
      <Flex align="center" justify="center" p="xl">
        <RedoSpinner />
      </Flex>
    );
  }

  if (events.length === 0) {
    return (
      <Flex align="center" justify="center" p="xl">
        <Text fontSize="xs" textColor="tertiary">
          No activity yet
        </Text>
      </Flex>
    );
  }

  return (
    <div className={styles.container}>
      {events.map((event) => (
        <TimelineEventCard event={event} key={event.id} />
      ))}
    </div>
  );
});
